const productFilter = {
  init: function () {
    this.container = document.getElementById("Collection");
    this.productGrids = document.querySelectorAll(".product-grid");
    this.mainProductGrid = document.getElementById("ProductGrid");
    this.loader = document.getElementById("infinite-scroll-loader");
    this.filterToggle = document.getElementById("in-stock-toggle");
    this.tagFilter = document.querySelector("[data-custom-tag-filter]");
    this.currentPage = 1;
    this.loading = false;
    this.allProductsLoaded = false;
    this.showOnlyInStock = false;
    this.currentTag = "";
    this.lastScrollTime = Date.now();
    this.totalPages = parseInt(this.container?.dataset?.totalPages) || 1;
    this.bindEvents();
  },

  bindEvents: function () {
    window.addEventListener(
      "scroll",
      this.debounce(this.checkScroll.bind(this), 50)
    );
    if (this.filterToggle) {
      this.filterToggle.addEventListener(
        "change",
        this.debounce(this.handleFilterChange.bind(this), 200)
      );
    }
    if (this.tagFilter) {
      this.tagFilter.addEventListener(
        "change",
        this.handleTagChange.bind(this)
      );
    }
  },

  debounce: function (func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  handleFilterChange: function () {
    this.showOnlyInStock = this.filterToggle.checked;
    this.resetAndReload();
  },

  handleTagChange: function (event) {
    event.preventDefault();
    this.currentTag = event.target.value;
    this.resetAndReload();
  },

  resetAndReload: function () {
    this.currentPage = 0;
    this.allProductsLoaded = false;
    if (this.mainProductGrid) {
      this.mainProductGrid.innerHTML = "";
    }
    this.showLoader();
    if (this.currentTag) {
      this.loadAllPages();
    } else {
      this.loadMoreUntilFull();
    }
  },

  loadAllPages: function () {
    const pagePromises = [];
    for (let page = 1; page <= this.totalPages; page++) {
      pagePromises.push(this.loadPage(page));
    }

    Promise.all(pagePromises)
      .then(() => {
        this.allProductsLoaded = true;
        this.filterAllProducts();
        this.revealProducts();
        this.hideLoader();
      })
      .catch((error) => {
        console.error("Error loading all pages:", error);
        this.hideLoader();
      });
  },

  loadPage: function (page) {
    return new Promise((resolve, reject) => {
      const baseUrl = window.location.pathname;
      let url = `${baseUrl}?sort_by=created-descending&page=${page}`;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newProductGrid = doc.getElementById("ProductGrid");
          if (newProductGrid && newProductGrid.children.length > 0) {
            this.appendNewProducts(newProductGrid);
          }
          resolve();
        })
        .catch((error) => {
          console.error(`Error loading page ${page}:`, error);
          reject(error);
        });
    });
  },

  loadMoreUntilFull: function () {
    this.loadMore().then(() => {
      if (
        this.mainProductGrid &&
        this.mainProductGrid.clientHeight < window.innerHeight &&
        !this.allProductsLoaded
      ) {
        this.loadMoreUntilFull();
      } else {
        this.revealProducts();
        this.hideLoader();
      }
    });
  },

  loadMore: function () {
    return new Promise((resolve, reject) => {
      if (this.loading || this.allProductsLoaded || !this.mainProductGrid) {
        resolve();
        return;
      }
      this.loading = true;
      const nextPage = this.currentPage + 1;
      this.loadPage(nextPage)
        .then(() => {
          this.currentPage = nextPage;
          this.loading = false;
          if (this.currentPage >= this.totalPages) {
            this.allProductsLoaded = true;
          }
          resolve();
        })
        .catch((error) => {
          console.error("Error loading more products:", error);
          this.loading = false;
          reject(error);
        });
    });
  },

  appendNewProducts: function (newProductGrid) {
    Array.from(newProductGrid.children).forEach((product) => {
      const productId = product.getAttribute("data-product-id");
      const productTag = product.getAttribute("data-product-tag");
      const isAvailable = !product.querySelector(".price--sold-out");
      const matchesTag = this.currentTag
        ? product.classList.contains(`tag-${this.currentTag}`)
        : true;
      if (
        (!this.showOnlyInStock || (this.showOnlyInStock && isAvailable)) &&
        matchesTag
      ) {
        const clone = product.cloneNode(true);
        clone.classList.add("new-item");
        if (productTag === "L/S Shirt") {
          productTag = "l-s-shirt";
        }
        clone.classList.add(`tag-${productTag}`);
        clone.setAttribute("data-product-tag", productTag);
        this.mainProductGrid.appendChild(clone);
      }
    });
  },

  filterAllProducts: function () {
    if (
      this.noProductsMessage &&
      this.mainProductGrid.contains(this.noProductsMessage)
    ) {
      this.mainProductGrid.removeChild(this.noProductsMessage);
    }

    if (!this.currentTag && !this.showOnlyInStock) {
      // If no tag is selected and we're not filtering for in-stock items, show all products
      const products = this.mainProductGrid.querySelectorAll(".grid__item");
      products.forEach((product) => (product.style.display = ""));
      return;
    }

    const products = this.mainProductGrid.querySelectorAll("li.grid__item");
    products.forEach((product) => {
      const isAvailable = !product.querySelector(".price--sold-out");
      const matchesTag = this.currentTag
        ? product.classList.contains(`tag-${this.currentTag}`)
        : true;
      product.style.display =
        (this.showOnlyInStock && !isAvailable) || !matchesTag ? "none" : "";

    });
  },

  revealProducts: function () {
    if (this.mainProductGrid) {
      const newProducts = this.mainProductGrid.querySelectorAll(
        ".grid__item.new-item"
      );
      const delay = Date.now() - this.lastScrollTime < 200 ? 0 : 50;
      let visibleProductsCount = 0;

      newProducts.forEach((product, index) => {
        setTimeout(() => {
          product.classList.add("loaded");
          product.classList.remove("new-item");
          if (product.style.display !== "none") {
            visibleProductsCount++;
          }
        }, delay);
      });

      // Check if there are any visible products after revealing
      setTimeout(() => {
        const allProducts =
          this.mainProductGrid.querySelectorAll(".grid__item");
        const visibleProducts = Array.from(allProducts).filter(
          (p) => p.style.display !== "none"
        );

        if (visibleProducts.length === 0) {
          this.showNoProductsMessage();
        } else if (
          this.noProductsMessage &&
          this.mainProductGrid.contains(this.noProductsMessage)
        ) {
          this.mainProductGrid.removeChild(this.noProductsMessage);
        }
      }, delay + 100); // Wait a bit after all products have been revealed
    }
  },

  checkScroll: function () {
    this.lastScrollTime = Date.now();
    if (
      this.loading ||
      this.allProductsLoaded ||
      !this.container ||
      this.currentTag
    )
      return;
    const scrollPosition = window.innerHeight + window.scrollY;
    const containerBottom =
      this.container.offsetTop + this.container.offsetHeight;
    if (scrollPosition > containerBottom - 500) {
      this.showLoader();
      this.loadMore().then(() => {
        this.filterAllProducts();
        this.revealProducts();
        this.hideLoader();
      });
    }
  },

  productExists: function (productId) {
    return (
      this.mainProductGrid.querySelector(`[data-product-id="${productId}"]`) !==
      null
    );
  },

  showNoProductsMessage: function () {
    if (!this.noProductsMessage) {
      this.noProductsMessage = document.createElement("div");
      this.noProductsMessage.className = "no-products-message";
      this.noProductsMessage.textContent = "No products found";
      this.noProductsMessage.style.textAlign = "center";
      this.noProductsMessage.style.padding = "20px";
      this.noProductsMessage.style.fontSize = "18px";
    }
    if (!this.mainProductGrid.contains(this.noProductsMessage)) {
      this.mainProductGrid.appendChild(this.noProductsMessage);
    }
  },

  showLoader: function () {
    if (this.loader) {
      this.loader.style.display = "block";
    }
  },

  hideLoader: function () {
    if (this.loader) {
      this.loader.style.display = "none";
    }
  },
};

document.addEventListener("DOMContentLoaded", function () {
  productFilter.init();
});
